// extracted by mini-css-extract-plugin
module.exports = {"ProfileTabs":"ProfileTabs_ProfileTabs__tWKgX","ProfileTabItem":"ProfileTabs_ProfileTabItem__ZLY4e","ProfileTabItemActive":"ProfileTabs_ProfileTabItemActive__Se7li"};